module.exports = __webpack_public_path__ + "img/treasure.553b9ed0.png";